import React from "react";

const PaginationControls = ({
  limit,
  offset,
  onLimitChange,
  onOffsetChange,
  disableNext = false,
  disabled = false,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <label className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
        Limit
      </label>
      <input
        type="number"
        min={1}
        max={1000}
        value={limit}
        onChange={(e) => onLimitChange(Number(e.target.value))}
        className="w-24 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700"
        disabled={disabled}
      />

      <label className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
        Offset
      </label>
      <input
        type="number"
        min={0}
        value={offset}
        onChange={(e) => onOffsetChange(Number(e.target.value))}
        className="w-24 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700"
        disabled={disabled}
      />

      <button
        type="button"
        className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 disabled:opacity-50"
        onClick={() => onOffsetChange(Math.max(0, offset - limit))}
        disabled={disabled || offset <= 0}
      >
        Prev
      </button>
      <button
        type="button"
        className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 disabled:opacity-50"
        onClick={() => onOffsetChange(offset + limit)}
        disabled={disabled || disableNext}
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControls;

